import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getZombieInstanceFromPrimaryKey } from '@iotv/iotv-v3-types';
import { Button, Stack, TextField } from '@mui/material';
import { JsonViewer } from '@dataxpdtn/mui-json-viewer';
import { useReducer } from 'react';
import { getItem } from '../../../../../data/Wideawake/wideawakeDataFns';
/** this could be made to support and array of filters which would be ANDed in the current setup */
export const GetItem = ({}) => {
    const defaultState = {
        sk: null,
        item: null,
    };
    const [state, dispatch] = useReducer((state, next) => {
        return { ...state, ...next };
    }, defaultState);
    const handleGetItemClick = async () => {
        dispatch({ item: null });
        if (typeof state.sk === 'string' && state.sk.length > 0) {
            const res = await getItem({ Item: getZombieInstanceFromPrimaryKey(state.sk) });
            if (res.data?.Item) {
                dispatch({ item: res.data.Item });
            }
            else if (res.data) {
                console.log('unexpected', res.data);
                dispatch({ item: null });
            }
            else {
                console.log('err in getItem', res.err?.message);
                dispatch({ item: null });
            }
        }
    };
    const handleJSONEdit = (attPath) => {
        const v = attPath.reduce((acc, pathPart) => {
            acc = acc ? acc[pathPart] : undefined;
            return acc;
        }, state.item);
        console.log('edited value', v, 'at path', attPath);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, { children: [_jsx(TextField, { label: "Enter PK to get Item", onChange: (e) => dispatch({ sk: e.target.value }), fullWidth: true }), _jsx(Button, { onClick: handleGetItemClick, variant: "outlined", color: "secondary", size: "small", disabled: !state.sk || state.sk.length === 0, children: state.item ? 'Refresh' : 'Query' })] }), _jsx(Stack, { direction: 'row', justifyContent: 'left', alignItems: 'flex-start', spacing: 2, children: _jsx("div", { style: { fontSize: 24 }, children: _jsx(JsonViewer, { value: state.item, displayDataTypes: false, editable: true, onChange: handleJSONEdit }, 'summary') }) })] }));
};
